"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _fetchHelper = require("@eig-builder/core-utils/helpers/fetch-helper");

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Schema submit helper, can be used for each schema to submit the values to the server
 *
 * @class SchemaSubmit
 */
var SchemaSubmit = /*#__PURE__*/function () {
  function SchemaSubmit() {
    (0, _classCallCheck2["default"])(this, SchemaSubmit);
  }

  (0, _createClass2["default"])(SchemaSubmit, [{
    key: "getOnSubmitForPostObject",
    value: function getOnSubmitForPostObject(values, schema, fetchOptions) {
      var api = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _urlHelper.siteNames.API;
      // Using resolveUrl because it contains the same logic
      var requestUrl;

      if (fetchOptions.useApiGateway) {
        if (!(0, _isEmpty["default"])(schema.reply_url) && schema.reply_url[0] === '{') {
          // Try to check if the options url has specified the endpoint for the gateway:
          // {gw:email-marketing}/v1.0/localization/countries/US/states/lookup
          var matches = schema.reply_url.match(/{gw:(.+?)}/);
          var matchesNoGw = schema.reply_url.match(/{(.+?)}/);

          if (matches) {
            requestUrl = (0, _urlHelper.api)(schema.reply_url.substr(matches[0].length), matches[1]);
          } else if (matchesNoGw) {
            requestUrl = (0, _urlHelper.api)(schema.reply_url.substr(matchesNoGw[0].length));
          }
        }
      } // When we don't have a request url, try to build one from scratch and assume it should go to the default api


      if (!requestUrl) {
        var runtimeConfig = (0, _runtimeConfigHelper.getRuntimeConfig)(); // Determine gateway endpoint. For now use the default api name.
        // If you want to use another endpoint, please use {gw:appname} in the backend

        var appGatewayEndpoint = api === _urlHelper.siteNames.API ? runtimeConfig._defaultApiName : api;
        var useAppGateway = runtimeConfig._enableAppGateway || false;
        requestUrl = useAppGateway ? (0, _urlHelper.api)(schema.reply_url, appGatewayEndpoint) : (0, _urlHelper.resolveUrl)(api, schema.reply_url);
      }

      var obj = _objectSpread({}, fetchOptions);

      obj.returnType = 'json'; // the extra argument will be used as defaultvalues if the submit call failed

      obj.extraArguments = values; // do put or post request

      switch (schema.reply_method.toLowerCase()) {
        case 'post':
          return (0, _fetchHelper.postAsJson)(requestUrl, values, obj);

        case 'put':
          return (0, _fetchHelper.putAsJson)(requestUrl, values, obj);
      }
    }
  }, {
    key: "getOnSubmit",
    value: function getOnSubmit(values, schema, fetchOptions) {
      var postObject = values;

      if (postObject) {
        return this.getOnSubmitForPostObject(postObject, schema, fetchOptions);
      }

      return null;
    }
    /**
     * Generic way to listen to schema submit call, this can be used in your redux "reducer"
     *
     * @param {object} state - prev state
     * @param {object} action - current action
     * @param {string} key - only listen to this key
     * @param {string} dataKey - this is a prefix, `${dataKey}Receiving`, `${dataKey}Response` or `${dataKey}Errors` will be filled
     * @param {func} convertFormValues - this is a callback with the new state object and the form values just filled in by the user. This can be used to fill your local state with new values
     * @returns {object} new state, will be null when its not the correct action.type
     *
     * @memberOf SchemaSubmit
     */

  }, {
    key: "listenToSubmit",
    value: function listenToSubmit(state, action, key, dataKey, convertFormValues) {
      dataKey = dataKey || (0, _camelCase["default"])(key);
      var obj = this.convertDataKeyToStateKeys(dataKey);

      switch (action.type) {
        case "".concat(key, "_PENDING"):
          var newPendingState = _objectSpread({}, state);

          newPendingState[obj.receivingKey] = true;
          newPendingState[obj.responseKey] = null;
          newPendingState[obj.errorsKey] = null;
          return newPendingState;

        case "".concat(key, "_FULFILLED"):
          var newState = _objectSpread({}, state);

          newState[obj.receivingKey] = false;
          newState[obj.responseKey] = action.body;

          if (convertFormValues) {
            convertFormValues(newState, action.extraArguments);
          }

          return newState;

        case "".concat(key, "_ERROR"):
          var newErrorState = _objectSpread({}, state);

          newErrorState[obj.receivingKey] = false;
          newErrorState[obj.errorsKey] = action.body;
          newErrorState[obj.valuesKey] = action.extraArguments;
          return newErrorState;
      }
    }
  }, {
    key: "convertDataKeyToStateKeys",
    value: function convertDataKeyToStateKeys(dataKey) {
      return {
        receivingKey: "".concat(dataKey, "Receiving"),
        responseKey: "".concat(dataKey, "Response"),
        errorsKey: "".concat(dataKey, "Errors"),
        valuesKey: "".concat(dataKey, "Values")
      };
    }
  }, {
    key: "resetSubmitStates",
    value: function resetSubmitStates(state, dataKey) {
      if (dataKey.indexOf('_') !== -1) {
        dataKey = (0, _camelCase["default"])(dataKey);
      }

      var obj = this.convertDataKeyToStateKeys(dataKey);
      state[obj.receivingKey] = false;
      state[obj.responseKey] = null;
      state[obj.errorsKey] = null;
      state[obj.valuesKey] = null;
      return state;
    }
  }]);
  return SchemaSubmit;
}();

var _default = new SchemaSubmit();

exports["default"] = _default;